import React, { useState, useEffect, useRef } from "react";
import noteIcon from "./img/note.webp";
import burgerIcon from "./img/menu-burger.png";
import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { statusfarben } from "./globalVariables";

export default function ProjektstatusAkquise({
   heading,
   abschnittsarray,
   updateStufenOptionen,
   topic,
}) {

   return (
      <div className="projektstatus-l2" style={{ width: "100%" }}>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => updateStufenOptionen({ key: topic, value: true })}
               className="clean-button "
               title="Bereich minimieren"
               style={{ position: "absolute", right: "10px" }}
            >
               _
            </button>
         </div>
         <h2>
            {abschnittsarray && abschnittsarray.length} {heading}
         </h2>
         {abschnittsarray && (
            <div className="projekt-status-expo projektstatus-l3">
               <table>
                  <thead>
                     <tr>
                        <th title="Aktueller Bearbeitungszustand der Stufe">Stufe</th>
                     </tr>
                  </thead>
                  <tbody>
                     {abschnittsarray.map((item) => {
                        return (
                           <tr key={"expokey_" + item.objektnr_extern}>
                              <td className="projektstatus-termin">
                                 <div>
                                    <a
                                       target="_blank"
                                       href={
                                          "/datenblatt?estateid=" +
                                          item.id +
                                          "&stufe=bewertungsergebnis&kachel=bewertungsergebnisAbsagesprüfung"
                                       }
                                       style={{
                                          color:
                                             item.projektstufenstatus.bewertungsergebnis === 4 ||
                                             item.projektstufenstatus.bewertungsergebnis === -1
                                                ? "#fff"
                                                : "#000",
                                          backgroundColor:
                                             item.projektstufenstatus.bewertungsergebnis === -1
                                                ? "#e00"
                                                : statusfarben[item.projektstufenstatus.bewertungsergebnis]
                                                  ? statusfarben[item.projektstufenstatus.bewertungsergebnis]
                                                  : "#fff",
                                       }}
                                    >
                                       BE
                                    </a>
                                 </div>
                              </td>
                              <td>
                                 <a
                                    target="_blank"
                                    title={item.objektbezeichnung}
                                    className="projektstatus-linkbutton me-1"
                                    style={{ fontWeight: 600, fontSize: "16px" }}
                                    href={"/datenblatt?estateid=" + item.id}
                                 >
                                    {(item.objektbezeichnung
                                       ? item.objektnr_extern + " - " + item.objektbezeichnung.slice(0, -5)
                                       : item.objektnr_extern) + " ↗"}
                                 </a>
                              </td>
                           </tr>
                        );
                     })}
                  </tbody>
               </table>
            </div>
         )}
      </div>
   );
}
